var Contact = /** @class */ (function () {
    function Contact() {
        this.name = new ContactNameDTO();
        this.company = new ContactCompanyDTO();
        this.emails = [];
        this.phones = [];
        this.addresses = [];
        this.urls = [];
        this.dates = [];
        this.tags = [];
        this.customFields = [];
        this.assignees = [];
    }
    return Contact;
}());
export { Contact };
var ContactNameDTO = /** @class */ (function () {
    function ContactNameDTO() {
    }
    return ContactNameDTO;
}());
export { ContactNameDTO };
var ContactCompanyDTO = /** @class */ (function () {
    function ContactCompanyDTO() {
    }
    return ContactCompanyDTO;
}());
export { ContactCompanyDTO };
var ContactEmailDTO = /** @class */ (function () {
    function ContactEmailDTO() {
        this.tag = '';
        this.emailStatus = 'transactional';
        this.siteMemberEmail = false;
    }
    return ContactEmailDTO;
}());
export { ContactEmailDTO };
var ContactPhoneDTO = /** @class */ (function () {
    function ContactPhoneDTO() {
        this.tag = '';
    }
    return ContactPhoneDTO;
}());
export { ContactPhoneDTO };
var ContactAddressDTO = /** @class */ (function () {
    function ContactAddressDTO() {
        this.tag = '';
    }
    return ContactAddressDTO;
}());
export { ContactAddressDTO };
var ContactUrlDTO = /** @class */ (function () {
    function ContactUrlDTO() {
        this.tag = '';
    }
    return ContactUrlDTO;
}());
export { ContactUrlDTO };
var ContactDateDTO = /** @class */ (function () {
    function ContactDateDTO() {
        this.tag = '';
    }
    return ContactDateDTO;
}());
export { ContactDateDTO };
export var ContactCustomFieldType;
(function (ContactCustomFieldType) {
    ContactCustomFieldType["Text"] = "text";
    ContactCustomFieldType["Number"] = "number";
    ContactCustomFieldType["Date"] = "date";
    ContactCustomFieldType["URL"] = "url";
})(ContactCustomFieldType || (ContactCustomFieldType = {}));
//# sourceMappingURL=types.js.map